import { useMemo } from 'react';
import { useServiceAccountContext } from '../../contexts/ServiceAccountContext';
import ServiceAccountsInsights from './ServiceAccountsInsights';
import ServiceAccountsProtected from './ServiceAccountsProtected';
import ServiceAccountsRiskLevels from './ServiceAccountsRiskLevels';

const ServiceAccountsStatistics = () => {
    const { onPremNHILicenseISPMEnabled, onPremNHILicenseITDREnabled, onPremNHILicenseProtectionEnabled } =
        useServiceAccountContext();

    const insightsColSpan = useMemo(() => {
        if ((onPremNHILicenseISPMEnabled || onPremNHILicenseITDREnabled) && onPremNHILicenseProtectionEnabled) {
            return 'col-span-4';
        }
        if (onPremNHILicenseISPMEnabled || onPremNHILicenseITDREnabled || onPremNHILicenseProtectionEnabled) {
            return 'col-span-7';
        }
        return 'col-span-10';
    }, [onPremNHILicenseISPMEnabled, onPremNHILicenseITDREnabled, onPremNHILicenseProtectionEnabled]);

    return (
        <div className="grid grid-cols-10 gap-4 w-full">
            <div className={insightsColSpan}>
                <ServiceAccountsInsights />
            </div>
            {onPremNHILicenseProtectionEnabled && (
                <div className="col-span-3">
                    <ServiceAccountsProtected />
                </div>
            )}
            {(onPremNHILicenseISPMEnabled || onPremNHILicenseITDREnabled) && (
                <div className="col-span-3">
                    <ServiceAccountsRiskLevels />
                </div>
            )}
        </div>
    );
};

export default ServiceAccountsStatistics;
